import { config } from '@/apollo/config';
import { BANNER_LIST_QUERY } from '@/apollo/graphql/queries/bannerQueries/bannerQueries';
import { Link } from '@/i18n/navigation';
import { useQuery } from '@apollo/client';
import Image from 'next/image';
import Skeleton from 'react-loading-skeleton';
import styles from './banner.module.scss';

const Banner = () => {
  const { data: bannerData, loading } = useQuery(BANNER_LIST_QUERY, {
    variables: { first: 1, filter: { bannerType: 'MAIN_CATALOG_TOP' } },
  });

  return (
    <>
      {loading ? (
        <div className={styles.skeleton}>
          <Skeleton />
        </div>
      ) : (
        bannerData?.banners?.edges?.length > 0 && (
          <Link href={bannerData?.banners?.edges[0]?.node?.url || '#'} passHref>
            <Image
              src={`${config.publicApiUrl}${bannerData?.banners?.edges[0]?.node?.image}`}
              alt="banner-image"
              layout="responsive"
              width={1920}
              height={72}
              className={styles.bannerImage}
            />
          </Link>
        )
      )}
    </>
  );
};

export default Banner;
